import { AfterViewInit, Component, Inject, OnDestroy } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { EnvironmentType } from '@libs/models/environment.type';
import { ENVIRONMENT } from '@libs/shared/injections/window';

@Component({
  selector: 'app-chat-helpcranch',
  template: '',
})
export class ChatHelpcranchComponent implements OnDestroy, AfterViewInit {
  constructor(
    @Inject(DOCUMENT) private document: Document,
    @Inject(ENVIRONMENT) private environment: EnvironmentType,
  ) {}

  public ngOnDestroy(): void {
    const arr: string[] = ['#helpcrunchChat', '#helpcrunchSettings', '#widgetSrc', '.helpcrunch-iframe-wrapper'];
    arr.forEach((id: string) => this.document.querySelector(id)?.remove());
  }

  public ngAfterViewInit(): void {
    this.initChatSettings();
    this.initChat();
  }

  private initChatSettings(): void {
    const script: HTMLScriptElement = this.document.createElement('script');
    script.textContent = `
      window.helpcrunchSettings = {
      organization: '${this.environment.helpCranchOrganization}',
      appId: '${this.environment.helpCranchKey}',};`;
    script.defer = true;
    script.type = 'text/javascript';
    script.id = 'helpcrunchSettings';
    this.document.head.appendChild(script);
  }

  private initChat(): void {
    const script: HTMLScriptElement = this.document.createElement('script');
    script.textContent = `
      (function (w, d) {
      var hS = w.helpcrunchSettings;
      if (!hS || !hS.organization) {
        return;
      }
      var widgetSrc = 'https://' + hS.organization + '.widget.helpcrunch.com/';
      w.HelpCrunch = function () {
        w.HelpCrunch.q.push(arguments);
      };
      w.HelpCrunch.q = [];

      function r() {
        if (d.querySelector('script[src="' + widgetSrc + '"')) {
          return;
        }
        var s = d.createElement('script');
        s.async = 1;
        s.type = 'text/javascript';
        s.src = widgetSrc;
        s.id = 'widgetSrc';
        (d.body || d.head).appendChild(s);
      }

      if (d.readyState === 'complete' || hS.loadImmediately) {
        r();
      } else if (w.attachEvent) {
        w.attachEvent('onload', r);
      } else {
        w.addEventListener('load', r, false);
      }
      })(window, document);`;
    script.defer = true;
    script.type = 'text/javascript';
    script.id = 'helpcrunchChat';
    this.document.head.appendChild(script);
  }
}
